import { Clear } from "@mui/icons-material";
import { IconButton, InputAdornment } from "@mui/material";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

import { AdornmentLens } from "@ryde/controls";
import { drawerManageColumnsSearchAtom } from "@ryde/shared";

import { TableSettingsSearchFieldStyled } from "./table-settings.styled";

export const TableSettingsSearch: FC = () => {
  const [searchText, setSearchText] = useRecoilState(
    drawerManageColumnsSearchAtom,
  );

  const showClear = searchText.trim();

  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      setSearchText("");
    };
  }, [setSearchText]);

  return (
    <TableSettingsSearchFieldStyled
      fullWidth
      placeholder={t("general.SEARCH")}
      value={searchText}
      data-e2e="search-settings"
      autoComplete="off"
      size="small"
      onChange={e => setSearchText(e.target.value)}
      slotProps={{
        input: {
          startAdornment: <AdornmentLens />,
          endAdornment: showClear ? (
            <InputAdornment position="end">
              <IconButton
                aria-label="Clear search field"
                onClick={() => setSearchText("")}
                edge="end"
              >
                <Clear />
              </IconButton>
            </InputAdornment>
          ) : undefined,
        },
      }}
    />
  );
};
